const iconEyes = document.querySelectorAll(".eye-icon");

if (iconEyes) {
  iconEyes.forEach((iconEye) => {
    iconEye.addEventListener("click", (event) => {

      // Use event.composedPath() instead of event.path, as event.path is undefined on Safari/Firefox
      // https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
      let eventPath = event.composedPath()

      if (!(eventPath[1].children[0].hasAttribute("type"))) return;
      const input = eventPath[1].children[0];
      const hidePassword = eventPath[1].querySelector(".hide-password");
      const showPassword = eventPath[1].querySelector(".show-password");

      if (input.getAttribute("type") === "password") {
        input.setAttribute("type", "text");
        hidePassword.classList.remove("d-none");
        showPassword.classList.add("d-none");

      } else {
        input.setAttribute("type", "password");
        hidePassword.classList.add("d-none");
        showPassword.classList.remove("d-none");
      }
    })
  })
}
